import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { RoleService, ProfilRole } from 'src/app/core/services/role.service';
import { RoleMenuConfigService, CLE_STOCKAGE_MENUS_ROLE } from 'src/app/core/services/role-menu-config.service';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';

interface MenuPossible {
  id: string;
  nom: string;
  icone: string;
  section: string;
  route: string;
}

@Component({
  selector: 'app-gestion-roles',
  templateUrl: './gestion-roles.component.html',
  styleUrls: ['./gestion-roles.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GestionRolesComponent implements OnInit {

  roles: any[] = [];
  chargement = true;
  sauvegarde = false;
  roleSelectionne: any | null = null;

  // ── Formulaire création / édition ──
  panneauOuvert = false;
  modeEdition = false;
  formProfil!: FormGroup;

  readonly ICONES_DISPONIBLES = [
    'fal fa-shield-check', 'fal fa-user-tie', 'fal fa-motorcycle',
    'fal fa-map-marker-alt', 'fal fa-calculator', 'fal fa-file-invoice-dollar',
    'fal fa-tools', 'fal fa-users-cog', 'fal fa-coins', 'fal fa-handshake',
    'fal fa-user', 'fal fa-users', 'fal fa-cog', 'fal fa-chart-bar', 'fal fa-star',
  ];

  readonly menusPossibles: MenuPossible[] = [
    // OPÉRATIONS
    { id: 'dashboard',               nom: 'Dashboard',               icone: 'fal fa-home',             section: 'Opérations',          route: '/dashboard' },
    { id: 'commandes',               nom: 'Commandes',               icone: 'fal fa-box-open',         section: 'Opérations',          route: '/commande/lister' },
    { id: 'commandes-urbain',        nom: 'Commandes — Urbain',      icone: 'fal fa-city',             section: 'Opérations',          route: '/commande/lister' },
    { id: 'commandes-interurbain',   nom: 'Commandes — Interurbain', icone: 'fal fa-route',            section: 'Opérations',          route: '/commande/interurbain' },
    { id: 'depotage',                nom: 'Dépôt & Tri',             icone: 'fal fa-warehouse',        section: 'Opérations',          route: '/commande/depotage' },
    { id: 'manifestes',              nom: 'Manifestes',              icone: 'fal fa-file-alt',         section: 'Opérations',          route: '/manifeste/lister' },
    { id: 'nouvelle-commande',       nom: 'Nouvelle commande',       icone: 'fal fa-plus-circle',      section: 'Opérations',          route: '/commande/enregistrer' },
    { id: 'suivi-live',              nom: 'Suivi en temps réel',     icone: 'fal fa-map-marker-exclamation', section: 'Opérations', route: '/suivi-live' },
    { id: 'kanban-dispatch',         nom: 'Kanban Dispatch',         icone: 'fal fa-columns',               section: 'Opérations', route: '/commandes/kanban' },
    { id: 'reclamations',            nom: 'Réclamations & Litiges',  icone: 'fal fa-comment-alt-exclamation', section: 'Opérations', route: '/reclamations' },
    { id: 'chat',                    nom: 'Chat & Messagerie',        icone: 'fal fa-comments',               section: 'Opérations', route: '/chat' },
    { id: 'planning',                nom: 'Planning & Disponibilités', icone: 'fal fa-calendar-alt',  section: 'Opérations',          route: '/planning' },
    // ESPACE LIVREUR
    { id: 'livreur-commandes',       nom: 'Livreur — Mes commandes',      icone: 'fal fa-box-check',       section: 'Espace livreur', route: '/livreur/mes-commandes' },
    { id: 'livreur-mon-bilan',       nom: 'Livreur — Mon bilan',          icone: 'fal fa-chart-bar',       section: 'Espace livreur', route: '/livreur/mon-bilan' },
    { id: 'livreur-fiches-paie',     nom: 'Livreur — Mes fiches de paie', icone: 'fal fa-file-invoice',    section: 'Espace livreur', route: '/livreur/mes-fiches-paie' },
    { id: 'zone-manager-espace',     nom: 'Espace Responsable Zone',      icone: 'fal fa-map-pin',         section: 'Espace livreur', route: '/zone-manager/dashboard' },
    // FINANCES
    { id: 'comptabilite',            nom: 'Comptabilité',                  icone: 'fal fa-calculator',           section: 'Finances', route: '/comptabilite/dashboard' },
    { id: 'comptabilite-dashboard',  nom: 'Comptabilité — Tableau de bord',icone: 'fal fa-chart-line',           section: 'Finances', route: '/comptabilite/dashboard' },
    { id: 'comptabilite-factures-dynamiques', nom: 'Factures dynamiques', icone: 'fal fa-file-invoice',         section: 'Finances', route: '/facturation' },
    { id: 'facturation-standard',    nom: 'Factures standard',             icone: 'fal fa-file-invoice-dollar',  section: 'Finances', route: '/facturation/factures' },
    { id: 'paiements',               nom: 'Paiements',                     icone: 'fal fa-money-check-alt',      section: 'Finances', route: '/paiements' },
    { id: 'finances-dashboard',      nom: 'Dashboard financier',           icone: 'fal fa-analytics',            section: 'Finances', route: '/finances/dashboard' },
    { id: 'creances-b2b',            nom: 'Créances B2B',                  icone: 'fal fa-file-exclamation',     section: 'Finances', route: '/creances' },
    { id: 'fiches-paie-livreurs',    nom: 'Fiches de paie livreurs',       icone: 'fal fa-file-invoice-dollar',  section: 'Finances', route: '/fiches-paie' },
    { id: 'rapports',                nom: 'Rapports & indicateurs',         icone: 'fal fa-chart-pie',            section: 'Finances', route: '/rapports' },
    { id: 'caisse',                  nom: 'Caisse & Encaissements',         icone: 'fal fa-cash-register',        section: 'Finances', route: '/caisse' },
    // CLIENTS & PARTENAIRES
    { id: 'clients',                 nom: 'Clients',                 icone: 'fal fa-user-friends',     section: 'Clients & Partenaires', route: '/utilisateur/lister' },
    { id: 'clients-standards',       nom: 'Clients standards',       icone: 'fal fa-user',             section: 'Clients & Partenaires', route: '/utilisateur/lister' },
    { id: 'clients-contrat',         nom: 'Clients sous contrat',    icone: 'fal fa-file-signature',   section: 'Clients & Partenaires', route: '/utilisateur/lister' },
    { id: 'partenaires',             nom: 'Partenaires',             icone: 'fal fa-handshake',        section: 'Clients & Partenaires', route: '/partenaires/liste' },
    { id: 'partenaires-liste',       nom: 'Partenaires — Liste',     icone: 'fal fa-list',             section: 'Clients & Partenaires', route: '/partenaires/liste' },
    { id: 'partenaires-nouveau',     nom: 'Partenaires — Ajouter',   icone: 'fal fa-plus-circle',      section: 'Clients & Partenaires', route: '/partenaires/nouveau' },
    { id: 'clients-liste',            nom: 'Clients — Tous',          icone: 'fal fa-list',             section: 'Clients & Partenaires', route: '/clients/liste' },
    { id: 'contrats',                nom: 'Contrats B2B',            icone: 'fal fa-file-contract',    section: 'Clients & Partenaires', route: '/contrats' },
    { id: 'contrats-liste',          nom: 'Contrats B2B — Liste',    icone: 'fal fa-list',             section: 'Clients & Partenaires', route: '/contrats' },
    { id: 'devis',                   nom: 'Demandes de devis',       icone: 'fal fa-file-search',      section: 'Clients & Partenaires', route: '/devis' },
    // ÉQUIPE
    { id: 'utilisateurs',            nom: 'Utilisateurs',              icone: 'fal fa-users',         section: 'Équipe', route: '/utilisateur/lister' },
    { id: 'utilisateurs-tous',       nom: 'Utilisateurs — Tous',       icone: 'fal fa-list',          section: 'Équipe', route: '/utilisateur/lister' },
    { id: 'utilisateurs-livreurs',   nom: 'Utilisateurs — Livreurs',   icone: 'fal fa-motorcycle',    section: 'Équipe', route: '/utilisateur/lister' },
    { id: 'utilisateurs-gestionnaires', nom: 'Utilisateurs — Resp. zone', icone: 'fal fa-map-pin',   section: 'Équipe', route: '/utilisateur/lister' },
    { id: 'utilisateurs-comptables', nom: 'Utilisateurs — Comptables', icone: 'fal fa-calculator',    section: 'Équipe', route: '/utilisateur/lister' },
    { id: 'mes-livreurs',            nom: 'Mes Livreurs (zone)',        icone: 'fal fa-motorcycle',    section: 'Équipe', route: '/utilisateur/lister' },
    { id: 'rh',                      nom: 'Ressources Humaines',        icone: 'fal fa-users-cog',     section: 'Équipe', route: '/rh' },
    { id: 'rh-personnel',            nom: 'RH — Fiches RH',            icone: 'fal fa-id-card',       section: 'Équipe', route: '/rh/personnel' },
    { id: 'rh-primes',               nom: 'RH — Primes mensuelles',    icone: 'fal fa-gift',          section: 'Équipe', route: '/rh/primes' },
    { id: 'rh-conges',               nom: 'RH — Congés & Absences',    icone: 'fal fa-umbrella-beach', section: 'Équipe', route: '/rh/conges' },
    { id: 'rh-configuration',        nom: 'RH — Configuration',        icone: 'fal fa-sliders-h',     section: 'Équipe', route: '/rh/configuration' },
    { id: 'evaluations-livreurs',    nom: 'Évaluations livreurs',      icone: 'fal fa-star',          section: 'Équipe', route: '/evaluations' },
    // ACTIFS
    { id: 'materiel',                nom: 'Matériel & Flotte',              icone: 'fal fa-tools',                  section: 'Actifs', route: '/materiel' },
    { id: 'materiel-liste',          nom: 'Matériel — Inventaire',          icone: 'fal fa-list-ul',                section: 'Actifs', route: '/materiel' },
    { id: 'materiel-affectations',   nom: 'Matériel — Affectations livreurs', icone: 'fal fa-link',                section: 'Actifs', route: '/materiel?tab=affectations' },
    { id: 'materiel-alertes',        nom: 'Matériel — Alertes documents',   icone: 'fal fa-exclamation-triangle',  section: 'Actifs', route: '/materiel?tab=alertes' },
    { id: 'maintenance-materiel',    nom: 'Planning Maintenance',           icone: 'fal fa-calendar-check',        section: 'Actifs', route: '/maintenance' },
    { id: 'vehicules',               nom: 'Véhicules',                      icone: 'fal fa-car-side',               section: 'Actifs', route: '/vehicules' },
    // CONFIGURATION
    { id: 'tarifs',                  nom: 'Tarifs',                  icone: 'fal fa-sack-dollar',      section: 'Configuration', route: '/tarif/configuration/lister' },
    { id: 'configuration-tarifaire', nom: 'Config. tarifaire',       icone: 'fal fa-sliders-h',        section: 'Configuration', route: '/tarif/configuration/enregistrer' },
    { id: 'zones',                   nom: 'Zones',                   icone: 'fal fa-map',              section: 'Configuration', route: '/zone/lister' },
    { id: 'trajets',                 nom: 'Trajets',                 icone: 'fal fa-map-marker-alt',   section: 'Configuration', route: '/trajet/lister' },
    { id: 'config-villes',           nom: 'Villes',                  icone: 'fal fa-city',             section: 'Configuration', route: '/configuration/villes' },
    { id: 'config-centres-tri',      nom: 'Centres de tri',          icone: 'fal fa-warehouse',        section: 'Configuration', route: '/configuration/centres-tri' },
    { id: 'config-types-conditionnement', nom: 'Types conditionnement', icone: 'fal fa-box-open',     section: 'Configuration', route: '/configuration/types-conditionnement' },
    { id: 'config-niveaux-livreur',  nom: 'Niveaux livreur',         icone: 'fal fa-medal',            section: 'Configuration', route: '/configuration/niveaux-livreur' },
    { id: 'config-faq',              nom: 'FAQ',                     icone: 'fal fa-question-circle',  section: 'Configuration', route: '/configuration/faq' },
    { id: 'parametres',              nom: 'Paramètres',              icone: 'fal fa-cog',              section: 'Configuration', route: '/parametres' },
    { id: 'parametrage-entreprise',  nom: 'Paramétrage entreprise',  icone: 'fal fa-building',         section: 'Configuration', route: '/parametrage-entreprise' },
    { id: 'notifications',           nom: 'Notifications',           icone: 'fal fa-bell',             section: 'Configuration', route: '/notifications' },
  ];

  get sections(): string[] {
    return [...new Set(this.menusPossibles.map(m => m.section))];
  }

  menusDeLaSection(section: string): MenuPossible[] {
    return this.menusPossibles.filter(m => m.section === section);
  }

  constructor(
    private fb: FormBuilder,
    private roleService: RoleService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private roleMenuConfigService: RoleMenuConfigService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.chargerRoles();
  }

  private initForm(profil?: any): void {
    this.formProfil = this.fb.group({
      name:        [profil?.name || '', [Validators.required, Validators.pattern(/^[A-Z0-9_]{2,60}$/)]],
      libelle:     [profil?.libelle || '', [Validators.required, Validators.maxLength(80)]],
      description: [profil?.description || ''],
      icone:       [profil?.icone || 'fal fa-user'],
    });
  }

  chargerRoles(): void {
    this.chargement = true;
    this.roleService.listerRoles().subscribe({
      next: (data) => {
        this.roles = data.map((p: ProfilRole) => ({
          ...p,
          menusAutorises: this.parseMenus(p.menusJson, p.name)
        }));
        this.roleSelectionne = this.roles[0] ?? null;
        this.chargement = false;
      },
      error: () => {
        this.roles = [];
        this.chargement = false;
      }
    });
  }

  private parseMenus(menusJson: string | undefined, roleName: string): string[] {
    if (menusJson) {
      try { return JSON.parse(menusJson); } catch { /* fallthrough */ }
    }
    // Fallback localStorage
    try {
      const raw = localStorage.getItem(CLE_STOCKAGE_MENUS_ROLE);
      const stored = raw ? JSON.parse(raw) : {};
      if (stored[roleName]) return stored[roleName];
    } catch { /* ignore */ }
    return this.getMenusDefaut(roleName);
  }

  // ── Panneau Nouveau profil ──────────────────────────────────────

  ouvrirNouveauProfil(): void {
    this.modeEdition = false;
    this.initForm();
    this.panneauOuvert = true;
  }

  ouvrirEditionProfil(role: any, event: Event): void {
    event.stopPropagation();
    this.modeEdition = true;
    this.initForm(role);
    this.formProfil.get('name')?.disable(); // nom non modifiable en édition
    this.panneauOuvert = true;
  }

  fermerPanneau(): void {
    this.panneauOuvert = false;
    this.formProfil.get('name')?.enable();
  }

  soumettreFormProfil(): void {
    if (this.formProfil.invalid) { this.formProfil.markAllAsTouched(); return; }
    const val = this.formProfil.getRawValue();
    const payload: ProfilRole = {
      name: val.name?.toUpperCase(),
      libelle: val.libelle,
      description: val.description,
      icone: val.icone,
    };
    if (this.modeEdition && this.roleSelectionne?.id) {
      this.roleService.modifierProfil(this.roleSelectionne.id, payload).subscribe({
        next: () => { this.snack('Profil modifié', 'success'); this.fermerPanneau(); this.chargerRoles(); },
        error: (e) => this.snack(e?.error?.message || 'Erreur lors de la modification', 'error')
      });
    } else {
      this.roleService.creerProfil(payload).subscribe({
        next: () => { this.snack('Profil créé', 'success'); this.fermerPanneau(); this.chargerRoles(); },
        error: (e) => this.snack(e?.error?.message || 'Erreur lors de la création', 'error')
      });
    }
  }

  supprimerProfil(role: any, event: Event): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '95vw', maxWidth: '420px',
      data: {
        title: 'Supprimer le profil',
        message: `Voulez-vous vraiment supprimer le profil « ${role.libelle} » ?`,
        confirmLabel: 'Supprimer',
        confirmStyle: 'danger',
      }
    });
    dialogRef.afterClosed().subscribe((ok: boolean) => {
      if (!ok || !role.id) return;
      this.roleService.supprimerProfil(role.id).subscribe({
        next: () => {
          this.snack('Profil supprimé', 'success');
          if (this.roleSelectionne?.id === role.id) this.roleSelectionne = null;
          this.chargerRoles();
        },
        error: () => this.snack('Erreur lors de la suppression', 'error')
      });
    });
  }

  // ── Permissions ──────────────────────────────────────────────

  estAutorise(role: any, menuId: string): boolean {
    return role.menusAutorises?.includes(menuId) ?? false;
  }

  toggleMenu(role: any, menuId: string): void {
    if (!role.menusAutorises) role.menusAutorises = [];
    const idx = role.menusAutorises.indexOf(menuId);
    if (idx > -1) role.menusAutorises.splice(idx, 1);
    else role.menusAutorises.push(menuId);
  }

  toutCocher(role: any): void { role.menusAutorises = this.menusPossibles.map(m => m.id); }
  toutDecocher(role: any): void { role.menusAutorises = ['dashboard', 'notifications']; }
  reinitialiserDefaut(role: any): void { role.menusAutorises = this.getMenusDefaut(role.name); }
  nbMenusAutorises(role: any): number { return (role.menusAutorises ?? []).length; }

  sauvegarderRole(role: any): void {
    this.sauvegarde = true;
    const menus: string[] = role.menusAutorises ?? [];
    const menusJson = JSON.stringify(menus);

    // Persistance locale
    try {
      const raw = localStorage.getItem(CLE_STOCKAGE_MENUS_ROLE);
      const data = raw ? JSON.parse(raw) : {};
      data[role.name] = menus;
      localStorage.setItem(CLE_STOCKAGE_MENUS_ROLE, JSON.stringify(data));
    } catch { /* ignore */ }

    // Persistance en base via API
    if (role.id) {
      this.roleService.sauvegarderMenus(role.id, menusJson).subscribe({
        next: () => {
          this.sauvegarde = false;
          this.roleMenuConfigService.notifierConfigMiseAJour();
          this.snack(`Permissions « ${role.libelle} » enregistrées`, 'success');
        },
        error: () => {
          this.sauvegarde = false;
          this.snack('Erreur API — permissions sauvegardées localement', 'warning');
          this.roleMenuConfigService.notifierConfigMiseAJour();
        }
      });
    } else {
      this.sauvegarde = false;
      this.roleMenuConfigService.notifierConfigMiseAJour();
      this.snack(`Permissions « ${role.libelle} » enregistrées`, 'success');
    }
  }

  private snack(msg: string, type: 'success' | 'error' | 'warning'): void {
    const cls = type === 'success' ? 'success-snackbar' : type === 'error' ? 'error-snackbar' : 'warning-snackbar';
    this.snackBar.open(msg, 'Fermer', {
      duration: 3500, horizontalPosition: 'right', verticalPosition: 'top', panelClass: [cls]
    });
  }

  getMenusDefaut(roleName: string): string[] {
    const map: Record<string, string[]> = {
      ADMIN: [
        'dashboard','commandes','commandes-urbain','commandes-interurbain','depotage','manifestes','nouvelle-commande',
        'suivi-live','kanban-dispatch','reclamations','chat','planning',
        'comptabilite','comptabilite-dashboard','comptabilite-factures-dynamiques','facturation-standard','paiements',
        'finances-dashboard','creances-b2b','fiches-paie-livreurs','rapports','caisse',
        'clients','clients-liste','clients-standards','clients-contrat','partenaires','partenaires-liste','partenaires-nouveau','contrats','contrats-liste','devis',
        'utilisateurs','utilisateurs-tous','utilisateurs-livreurs','utilisateurs-gestionnaires','utilisateurs-comptables',
        'rh','rh-personnel','rh-primes','rh-conges','rh-configuration','evaluations-livreurs',
        'materiel','materiel-liste','materiel-affectations','materiel-alertes','maintenance-materiel','vehicules',
        'tarifs','configuration-tarifaire','zones','trajets',
        'config-villes','config-centres-tri','config-types-conditionnement','config-niveaux-livreur','config-faq',
        'parametres','parametrage-entreprise','notifications'
      ],
      MANAGER: [
        'dashboard','commandes','commandes-urbain','commandes-interurbain','depotage','manifestes','nouvelle-commande',
        'suivi-live','kanban-dispatch','reclamations','chat','planning',
        'comptabilite','comptabilite-dashboard','comptabilite-factures-dynamiques','facturation-standard','paiements',
        'finances-dashboard','creances-b2b','fiches-paie-livreurs','rapports','caisse',
        'clients','clients-liste','clients-standards','clients-contrat','partenaires','partenaires-liste','contrats','contrats-liste','devis',
        'utilisateurs','utilisateurs-tous','utilisateurs-livreurs','utilisateurs-gestionnaires','utilisateurs-comptables',
        'rh','rh-personnel','rh-primes','rh-conges','evaluations-livreurs',
        'materiel','materiel-liste','materiel-affectations','materiel-alertes','maintenance-materiel','vehicules',
        'tarifs','zones','trajets','config-villes','config-centres-tri','config-types-conditionnement','config-niveaux-livreur','notifications'
      ],
      LIVREUR: ['dashboard','livreur-commandes','livreur-mon-bilan','livreur-fiches-paie','chat','notifications'],
      RESPONSABLE_ZONE: [
        'dashboard','zone-manager-espace','commandes','commandes-urbain','commandes-interurbain','depotage','manifestes',
        'suivi-live','kanban-dispatch','reclamations','chat','planning',
        'clients','clients-liste','clients-standards','clients-contrat','mes-livreurs','evaluations-livreurs','rapports',
        'config-centres-tri','notifications'
      ],
      COMPTABLE_ZONE: ['dashboard','comptabilite','comptabilite-dashboard','facturation-standard','paiements','caisse','creances-b2b','clients','clients-standards','clients-contrat','notifications'],
      COMPTABLE_GENERAL: [
        'dashboard','comptabilite','comptabilite-dashboard','comptabilite-factures-dynamiques','facturation-standard','paiements',
        'finances-dashboard','creances-b2b','fiches-paie-livreurs','rapports','caisse',
        'clients','clients-standards','clients-contrat','notifications'
      ],
      RESPONSABLE_MATERIEL: ['dashboard','materiel','materiel-liste','materiel-affectations','materiel-alertes','maintenance-materiel','vehicules','notifications'],
      RESPONSABLE_RH: ['dashboard','rh','rh-personnel','rh-primes','rh-conges','rh-configuration','evaluations-livreurs','fiches-paie-livreurs','config-niveaux-livreur','planning','notifications'],
      COMPTABLE: ['dashboard','comptabilite','comptabilite-dashboard','facturation-standard','paiements','caisse','creances-b2b','fiches-paie-livreurs','rh-primes','contrats','contrats-liste','notifications'],
      GESTIONNAIRE_PARTENARIATS: ['dashboard','partenaires','partenaires-liste','contrats','contrats-liste','clients','clients-standards','clients-contrat','chat','notifications'],
    };
    return map[roleName] ?? ['dashboard','notifications'];
  }
}
